import { client, env } from 'config/environment'
import Head from 'next/head'
import { getImageMimeType } from 'util/image'

interface MetaTagsProps {
  title?: string
  description?: string
  image?: string
  url?: string
  siteName?: string
  type?: string
  icon?: string
}

export function MetaTags({
  title,
  description,
  image,
  url,
  siteName,
  type = 'website',
  icon = '/favicon.png',
}: MetaTagsProps) {
  const atelier = env.domain === 'atelier'

  const defaultTitle = atelier ? 'Atelier Digital' : 'Dresscode'
  const defaultDescription = atelier
    ? 'Discover and try on outfits with Atelier Digital'
    : 'Discover and try on outfits with Dresscode'
  const defaultSiteName = atelier ? 'Atelier Digital' : 'Dresscode'

  title ||= defaultTitle
  description ||= defaultDescription
  siteName ||= defaultSiteName

  const currentUrl = url || (client ? window.location.href : '')
  const imageMimeType = image ? getImageMimeType(image) : 'image/png'

  return (
    <Head>
      {/* Основные мета-теги */}
      <title>{title}</title>
      <link rel="icon" href={icon} />
      <meta name="description" content={description} />

      {/* Open Graph мета-теги */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content={type} />
      {image && (
        <>
          <meta property="og:image" content={image} />
          <meta property="og:image:secure_url" content={image} />
          <meta property="og:image:type" content={imageMimeType} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </>
      )}

      {/* Twitter Card мета-теги */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {/* Дополнительные мета-теги */}
      <meta name="viewport" content="width=device-width,initial-scale=1,user-scalable=no" />
      <meta charSet="utf-8" />
    </Head>
  )
}
